module.exports = __webpack_public_path__ + "static/img/2_1_2_3.f2e6530c.jpg";